import React from "react";
import { displayFile } from "../constant";
import { Col } from "reactstrap";

const InfoField = React.memo(
  ({ label = "", value = "", flag = false, index, extraComponent: ExtraComponent, dropdownData }) => {

    const renderValue = () => {
      if (ExtraComponent) return <ExtraComponent value={value} label={label} dropdownData={dropdownData} />;

      if (Array.isArray(value)) {
        if (label == "Attachment") {
          try {
            return value?.length ? displayFile(value) : "-";
          } catch {
            return "-";
          }
        }
        return value?.length ? value.join(", ") : "-";
      }
      if(label=='Attachment'&&!Array.isArray(value)){
         return value?.length ? displayFile([value]) : "-";
      }

      if (value == null || String(value).trim() === "") return "-";

      return value;
    };

    return (
      <>
        <Col md={4} className="mt-24">
          <div>
            <div className="large-semi-bold label-color text-truncate">
              {renderValue()}
            </div>
            <div className="regular-small">{label || "-"}</div>
          </div>
        </Col>

        {/* Maintain grid alignment after 5th position */}
        {flag && index === 4 && <Col md={4} className="mt-24" />}
      </>
    );
  }
);

export default InfoField;
